module.exports = __webpack_public_path__ + "vue/img/platforms-ru.f6567444.svg";